import React from 'react';

import { flagStyles } from '../settings';

const SvgAX = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-312px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAX;
